export const FormattedTimestamp = () =>{
    const currentTimestamp = new Date();
    const formattedTimestamp = currentTimestamp.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
    }).replace(',', '');
    return {formattedTimestamp};
}